import {Component, EventEmitter, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {LoadingService} from "../../services/LoadingService";
import {TOAST_TYPE} from "../../constants/Tpiq.constants";
import {ToastService} from "../../services/Toast.service";
import {TaxPlanningService} from "../../tpiq-services/tax-planning.service";
import {StateService} from "../../services/StateService";
import {SwitchBoard} from "../../services/SwitchBoard";
import {Router} from "@angular/router";
import {PageTitleService} from "../../services/PageTitle";
import {takeUntil} from "rxjs/operators";
import {Session} from "../../services/Session";
import {isValidEmail} from "../../utils/validators";

@Component({
  selector: 'app-firm-creation',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './firm-creation.component.html',
  styleUrl: './firm-creation.component.scss'
})
export class FirmCreationComponent implements OnInit, OnDestroy {
  readonly isValidEmail = isValidEmail;

  user: any = {};
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  newFirmObj: any = {
    login_logo_url: 'https://static.taxplaniq.com/futurefirm/text_image.png',
    favicon_url: 'https://static.taxplaniq.com/futurefirm/favicon_new.png'
  };

  constructor(
    private router: Router,
    private toastService: ToastService,
    private loadingService: LoadingService,
    private taxPlanningService: TaxPlanningService,
    private titleService: PageTitleService,
    private switchBoard: SwitchBoard,
    private _router: Router,
    private stateService: StateService,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.user = Session.getUser();
    this.titleService.setPageTitle('Create Firm');
    this.switchBoard.onPageChangeListener.next({});
    this.switchBoard.onClickPrev.pipe(takeUntil(this.destroy$)).subscribe(title => {
      const prevState = this.stateService.getPrevState();
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    });

  }

  createFirm(){
    if (this.validateData()) {
      let obj = {
        "content": {
          "customer": {
            "id": "", 
            "first_name": this.newFirmObj.firstName,
            "last_name": this.newFirmObj.lastName,
            "email": this.newFirmObj.email,
            "phone": "",
            "company": this.newFirmObj.firmName,
            "cf_firm_website_url": this.newFirmObj.website
          }
        },
        "event_type": "customer_created"
      };
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.createFirm(obj).subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.toastService.pop(TOAST_TYPE.success, 'Tax planning firm created and sent an invitation');
        const prevState = this.stateService.getPrevState();
        this.stateService.pop();
        this._router.navigate([prevState.url]);
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        const message = error.message ? error.message : `Failed to create tax planning firm`;
        try {
          this.toastService.pop(TOAST_TYPE.error, message);
        } catch (e) {
          this.toastService.pop(TOAST_TYPE.error, message);
        }
      });
    }
  }

  sendInvitation(){
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.sendTaxPlanningInvitation(this.newFirmObj.email, this.newFirmObj.orgId).subscribe(response => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.success, 'Invitation Sent');
      const prevState = this.stateService.getPrevState();
      this.stateService.pop();
      this._router.navigate([prevState.url]);
    }, error => {
      this.loadingService.triggerLoadingEvent(false);
      this.toastService.pop(TOAST_TYPE.error, 'Failed to send invitation');
    });
  }

  validateData(){
    if (!this.newFirmObj.firmName){
      this.toastService.pop(TOAST_TYPE.error, 'Enter Firm name');
      return false;
    } else if (!this.newFirmObj.email){
      this.toastService.pop(TOAST_TYPE.error, 'Enter Firm email');
      return false;
    } else if (this.newFirmObj.email && !isValidEmail(this.newFirmObj.email)){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter a valid email');
      return false;
    } else if (!this.newFirmObj.firstName){
      this.toastService.pop(TOAST_TYPE.error, 'Enter User First name');
      return false;
    } else if (!this.newFirmObj.lastName){
      this.toastService.pop(TOAST_TYPE.error, 'Enter User Last name');
      return false;
    } else if (!this.newFirmObj.website){
      this.toastService.pop(TOAST_TYPE.error, 'Enter Website');
      return false;
    } else if (!this.newFirmObj.orgId){
      this.toastService.pop(TOAST_TYPE.error, 'Enter Org');
      return false;
    }
    return true;
  }

}
